import React from "react";
import "./VideoBox.scss";
import { IoCloseCircleOutline } from "react-icons/io5";

const VideoBox = ({ videoLink, closeVideoBox }: any) => {
  let videoSrc = "";

  function convertToEmbedUrl() {
    const match = videoLink.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/
    );
    videoSrc = `https://www.youtube.com/embed/${match[1]}`;
  }
  convertToEmbedUrl();
  console.log(videoSrc);
  console.log(videoLink);
  return (
    <div className="video-box">
      <IoCloseCircleOutline
        className="video-box-icon"
        arial-label="Close modal"
        onClick={closeVideoBox}
      />
      <div className="video-box-inner">
        <span className="loader"></span>
        <iframe
          //className="modal__video-style"
          loading="lazy"
          width="100%"
          height="100%"
          //src={videoLink}
          src={videoSrc}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
      <div>
        <audio src="#"></audio>
      </div>
    </div>
  );
};

export default VideoBox;
